<template>
    <div class="field-wrapper"
        :class="{ design: !!isDesign, selected: !!isDesign && selectWidget && selectWidget.id == widget.id }"
        @click.stop="clickWidget(widget)">
        <template v-if="widget.type == 'button'">
            <div class="static-content-item" v-if="!widget.hidden || !!isDesign">
                <slot></slot>
            </div>
        </template>
        <template v-else>
            <a-form-item v-if="!widget.hidden || !!isDesign" :label="widget.label" :name="widget.name" :rules="rules"
                :label-col="labelCol" :label-align="labelAlign">
                <slot></slot>
            </a-form-item>
        </template>

        <template v-if="!!isDesign && selectWidget && selectWidget.id == widget.id">
            <div class="field-action">
                <i @click.stop="moveUpWidget"><arrow-up-outlined /></i>
                <i @click.stop="moveDownWidget"><arrow-down-outlined /></i>
                <i @click.stop="removeFieldWidget"><delete-outlined /></i>
            </div>

            <div class="drag-handler background-opacity">
                <i>{{ entocn }}</i>
            </div>
        </template>
    </div>
</template>

<script setup>
import { ref, toRefs, computed, inject, defineExpose, toRaw } from 'vue';
import FormValidators from "./validators";
import useItem from '../useItem';

const props = defineProps({
    formData: Object,
    widget: Object,
    isDesign: Boolean,
    widgetList: Array,
    indexOfParentList: Number
})
const { formData, widget, isDesign, widgetList, indexOfParentList } = toRefs(props)

const { getSelectWidget, getFormConfig } = inject("designer")
const { getInstanceList } = inject("instance")
const instanceList = getInstanceList();

const selectWidget = computed(() => getSelectWidget())
const labelCol = computed(() => { return { style: { width: (widget.value.labelWidth || getFormConfig().labelWidth || '80') + 'px' } } })
const labelAlign = computed(() => widget.value.labelAlign || getFormConfig().labelAlign || 'left')
const entocn = computed(() => {
    const obj = {
        input: "单行输入",
        textarea: "多行输入",
        number: "计数器",
        password: "密码",
        radio: "单选框",
        checkbox: "多选框",
        select: "下拉选择",
        upload: "文件上传",
        time: "时间",
        "time-range": "时间范围",
        date: "日期",
        "date-range": "日期范围",
        switch: "开关",
        speak: "语音输出",
        button: "按钮",
        "rich-editor": "富文本",
    }
    return obj[widget.value.type]
});
const rules = computed(() => {
    let rules = []
    if (!!widget.value.options.required) {
        rules.push({
            required: true,
            //trigger: ['blur', 'change'],
            trigger: ['blur'],  /* 去掉change事件触发校验，change事件触发时formModel数据尚未更新，导致radio/checkbox必填校验出错！！ */
            message: widget.value.options.requiredHint || 'render.hint.fieldRequired',
        })
    }

    if (!!widget.value.options.validation) {
        let vldName = widget.value.options.validation
        if (!!FormValidators[vldName]) {
            rules.push({
                validator: FormValidators[vldName],
                trigger: ['blur', 'change'],
                label: widget.value.options.label,
                errorMsg: widget.value.options.validationHint
            })
        } else {
            rules.push({
                validator: FormValidators['regExp'],
                trigger: ['blur', 'change'],
                regExp: vldName,
                label: widget.value.options.label,
                errorMsg: widget.value.options.validationHint
            })
        }
    }
    //   if (!!widget.value.options.onValidate) {
    //     let customFn = (rule, value, callback) => {
    //       let tmpFunc =  new Function('rule', 'value', 'callback', widget.value.options.onValidate)
    //       return tmpFunc.call(this, rule, value, callback)
    //     }
    //     this.rules.push({
    //       validator: customFn,
    //       trigger: ['blur', 'change'],
    //       label: widget.value.options.label
    //     })
    //   }
    return rules
})

const {
    moveUpWidget,
    moveDownWidget,
    removeFieldWidget,
    clickWidget,
} = useItem(isDesign, widgetList, indexOfParentList)

const getInstance = (name) => {
    return instanceList[name];
};
const setDisabled = (flag) => {
    widget.value.options.disabled = flag || !widget.value.options.disabled;
};
const setOnlyRead = (flag) => {
    widget.value.options.onlyread = flag || !widget.value.options.onlyread;
};
const setClearable = (flag) => {
    widget.value.options.allowClear = flag || !widget.value.options.allowClear;
};
const setHidden = (flag) => {
    widget.value.hidden = flag || !widget.value.options.hidden;
};
const getProptype = (key) => {
    return widget.value.options[key];
};
const setProptype = (key, value) => {
    widget.value.options[key] = value;
};
const setValue = (value) => {
    formData.value[widget.value.name] = value;
};
defineExpose({ getInstance, setDisabled, setOnlyRead, setClearable, setHidden, getProptype, setProptype, setValue })
</script>

<style lang="scss" scoped>
.design {
    margin-bottom: 10px;
    position: relative;

    .ant-form-item {
        margin: 0 !important;
    }
}

.static-content-item {
    min-height: 20px;
    display: flex;
    /* 垂直居中 */
    align-items: center;
    /* 垂直居中 */
}

.field-action {
    position: absolute;
    bottom: 0;
    right: -2px;
    height: 22px;
    line-height: 22px;
    background: blue;
    z-index: 999;
}

.drag-handler {
    position: absolute;
    top: 0;
    left: -1px;
    height: 20px;
    line-height: 20px;
    background: blue;
    z-index: 9;
}

.drag-handler:hover {
    background: blue;
}

i {
    font-size: 14px;
    color: #fff;
    margin: 0 3px;
    cursor: pointer;
}

.selected {
    border: 2px solid blue;
}
</style>